import axios from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { BFF_SERVICE } from '../../utils/constants'
import storage from '../../utils/storageService'
import { groupsForStudent } from '../types'

export const getGroupsBySubjectsAndLanguage = createAsyncThunk(
    'group/getBySubjectsAndLanguage',
    async ({ subjectIds, languageEnum }: groupsForStudent, { rejectWithValue }) => {
        try {
            const token = storage?.get('token')
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    authorization: `Bearer ${token}`,
                },
            }

            const result = await axios.get(
                BFF_SERVICE +
                    `/student-group/get-for-student?subjectIds=${subjectIds}&languageEnum=${languageEnum}`,
                config,
            )

            return result.data.data
        } catch (error) {
            // return custom error message from API if any
            return rejectWithValue(error.response.data)
        }
    },
)
